import SearchInput from 'components/SearchInput';
import { TableFilterRow } from 'components/TableList';

import { IDepartmentsFiltersProps } from '../types';

export const DepartmentFilters = ({
  onPageChange,
  params
}: IDepartmentsFiltersProps): JSX.Element => {
  const handleSearch = (value: string) => {
    onPageChange({ search: value || undefined, offset: undefined });
  };

  return (
    <TableFilterRow>
      <SearchInput
        value={(params.search as string) || ''}
        onSearch={handleSearch}
        placeholder={'Search for Department Name'}
      />
    </TableFilterRow>
  );
};
